import { render, staticRenderFns } from "./ShowBalance.vue?vue&type=template&id=3158eacd&scoped=true&"
import script from "./ShowBalance.vue?vue&type=script&lang=js&"
export * from "./ShowBalance.vue?vue&type=script&lang=js&"
import style0 from "./ShowBalance.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ShowBalance.vue?vue&type=style&index=1&id=3158eacd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158eacd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VIcon,VList,VListItem,VListItemIcon,VListItemTitle,VMenu,VRow})
